import { InputSelect } from "@UI/InputNew";
import { useMemo } from 'react';
import s from './index.module.css';

const Time = ({changeRegularity, index, hourEnd, minutesEnd, firstField}) => {
    const optionsHour = useMemo(()=>{
        const option = [];
        for(let i=0; i < 24; i++){
            option.push(
                {
                    label: `${i}`,
                    value: i
                }
            )
        }
        return option;
    }, [])

    const optionsMinutes = useMemo(()=>{
        const option = [];
        for(let i=0; i < 60; i++){
            option.push(
                {
                    label: `${i}`,
                    value: i
                }
            )
        }
        return option;
    }, [])

    return (
        <>
            <InputSelect
                options={optionsHour}
                newDesign
                value={hourEnd}
                onChange={
                    (e) => {
                        changeRegularity(index, e.target.value, firstField, 'hourEnd')
                    }
                }
                className={s.select} 
                classNameBox={s.selectBox}
                hideIcon={true}
                popupClassName={s.popupClassName}
            />
            <InputSelect
                options={optionsMinutes}
                newDesign
                value={minutesEnd}
                onChange={
                    (e) => {
                        changeRegularity(index, e.target.value, firstField, 'minutesEnd')
                    }
                }
                className={s.select} 
                classNameBox={s.selectBox}
                hideIcon={true}
                popupClassName={s.popupClassName}
            />
        </>
    )
}

export default Time;